// extracted by mini-css-extract-plugin
export default {"card":"CursoCard_card__-HYWN","cardImageContainer":"CursoCard_cardImageContainer__+5UBI","cardFooter":"CursoCard_cardFooter__ZdH6e"};